/**
 * Back in Stock (BIS): invia iscrizioni "Avvisami quando disponibile" tramite AMP Back in Stock app.
 * Richiede: app AMP Back in Stock installata e attiva sullo store.
 * L'oggetto globale BIS viene iniettato dall'app.
 */
(function () {
  'use strict';

  var formSelector = '[data-notification-form]';

  function isBISAvailable() {
    return typeof BIS !== 'undefined' && typeof BIS.create === 'function';
  }

  function getFormData(form) {
    var emailInput = form.querySelector('input[name="contact[email]"]') || form.querySelector('#NotificaitonFormEmail');
    var email = emailInput ? (emailInput.value || '').trim() : '';
    var variantId = form.getAttribute('data-variant-id') || '';
    var productId = form.getAttribute('data-product-id') || '';
    return { email: email, variantId: variantId, productId: productId };
  }

  function showSuccess(form) {
    var container = form.closest('product-notification');
    if (!container) return;
    var heading = container.querySelector('[data-product-notification-heading]');
    var successEl = form.querySelector('[data-bis-success]');
    var fieldsEl = form.querySelector('[data-notification-form-fields]');
    var popup = container.closest('popup-component') || container.closest('.product-modal');
    if (heading) heading.classList.add('hidden');
    if (successEl) successEl.style.display = '';
    if (fieldsEl) fieldsEl.style.display = 'none';
    if (popup) popup.classList.add('has-success');
  }

  function showError(form) {
    var fieldsEl = form.querySelector('[data-notification-form-fields]');
    if (fieldsEl) {
      var err = fieldsEl.querySelector('.product__notification__error');
      if (!err) {
        err = document.createElement('p');
        err.className = 'product__notification__error';
        err.setAttribute('role', 'alert');
        err.style.color = '#c00';
        err.style.marginTop = '0.5em';
        fieldsEl.insertBefore(err, fieldsEl.firstChild);
      }
      err.textContent = window.notifyMe ? window.notifyMe.error : 'Si è verificato un errore. Riprova più tardi.';
      err.style.display = '';
    }
  }

  function setButtonLoading(form, loading) {
    var btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    if (loading) {
      btn.disabled = true;
      if (btn.querySelector('span')) btn.querySelector('span').textContent = 'Invio...';
    } else {
      btn.disabled = false;
      if (btn.querySelector('span')) btn.querySelector('span').textContent = btn.getAttribute('data-bis-original-text') || 'Avvisami';
    }
  }

  function handleSubmit(ev) {
    if (!isBISAvailable()) return;

    var form = ev.target;
    if (!form || !form.matches(formSelector)) return;

    ev.preventDefault();
    ev.stopImmediatePropagation();

    var data = getFormData(form);
    if (!data.email) {
      showError(form);
      return;
    }

    var btn = form.querySelector('button[type="submit"]');
    if (btn && btn.querySelector('span')) btn.setAttribute('data-bis-original-text', btn.querySelector('span').textContent);
    setButtonLoading(form, true);

    var errEl = form.querySelector('.product__notification__error');
    if (errEl) errEl.style.display = 'none';

    var notifyVariant = parseInt(data.variantId, 10);

    BIS.create(data.email, notifyVariant, data.productId)
      .then(function (response) {
        setButtonLoading(form, false);
        if (response && response.status === 'OK') {
          showSuccess(form);
        } else {
          showError(form);
        }
      })
      .catch(function () {
        setButtonLoading(form, false);
        showError(form);
      });
  }

  function init() {
    document.addEventListener('submit', handleSubmit, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
